import type { GuardianTeenDetailResponse } from "../../../../types/guardianTypes";
import { buildTeenLocationLines, formatDate } from "./utils";

type TeenProfileInfoCardProps = {
  teen: GuardianTeenDetailResponse;
};

const TeenProfileInfoCard = ({ teen }: TeenProfileInfoCardProps) => {
  const locationLines = buildTeenLocationLines(teen);

  return (
    <section className="rounded-[2rem] border border-myteengig-border bg-white p-6 shadow-sm">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Profile Details</p>
        <h2 className="mt-2 text-2xl font-semibold tracking-tight text-myteengig-text-primary">Teen information at a glance</h2>
      </div>

      <dl className="mt-6 grid gap-5 sm:grid-cols-2">
        <div>
          <dt className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Name</dt>
          <dd className="mt-2 text-base font-semibold text-myteengig-text-primary">{teen.firstName} {teen.lastName}</dd>
        </div>
        <div>
          <dt className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Date of Birth</dt>
          <dd className="mt-2 text-base font-semibold text-myteengig-text-primary">{formatDate(teen.dateOfBirth)}</dd>
        </div>
        <div>
          <dt className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Email</dt>
          <dd className="mt-2 text-base font-semibold text-myteengig-text-primary">{teen.email}</dd>
        </div>
        <div>
          <dt className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Account Status</dt>
          <dd className="mt-2 text-base font-semibold text-myteengig-text-primary">{teen.status}</dd>
        </div>
        <div className="sm:col-span-2">
          <dt className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">Location</dt>
          <dd className="mt-2 space-y-1 text-sm text-myteengig-text-primary">
            {locationLines.map((line) => (
              <div key={line}>{line}</div>
            ))}
          </dd>
        </div>
      </dl>
    </section>
  );
};

export default TeenProfileInfoCard;
